import { render, staticRenderFns } from "./deletePaymentPool.vue?vue&type=template&id=235e6a28&scoped=true"
import script from "./deletePaymentPool.vue?vue&type=script&lang=js"
export * from "./deletePaymentPool.vue?vue&type=script&lang=js"
import style0 from "./deletePaymentPool.vue?vue&type=style&index=0&id=235e6a28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235e6a28",
  null
  
)

export default component.exports